import $ from 'jquery'
import { tsInitVue } from "./js-utils"
import CandidatesGrid from "../js/vue-components/candidates-grid.vue"
import CandidateEventsGrid from "../js/vue-components/candidate-events-grid.vue"
import CandidateModal from "../js/vue-components/candidate-modal.vue"
import { initializeAutocompleteField } from "./site-utils"

document.addEventListener('DOMContentLoaded', function () {
  if ($('body.candidates.candidates-list').length) {
    const candidatesGridEl = document.querySelector('div[data-is="CandidatesGrid"]')
    if (candidatesGridEl instanceof HTMLElement) {
      window.cManager = tsInitVue(CandidatesGrid, candidatesGridEl, {
        listUrl: candidatesGridEl.dataset.listUrl
      })

      const searchFieldEl = document.querySelector('select[ref="candidate-search"]')
      if (searchFieldEl instanceof HTMLSelectElement) {
        const $searchField = initializeAutocompleteField(searchFieldEl)
        if ($searchField) {
          $searchField.on('select2:select', function (e) {
            if (e.params.data.id) {
              history.pushState({ q: e.params.data }, 'Candidate search', `?q=${e.params.data.id}`)
              window.cManager?.fetchContent(e.params.data)
            }
          })

          $searchField.on('select2:unselect', function () {
            history.pushState({ q: null }, 'Candidate search', `?`)
            window.cManager?.fetchContent()
          })
        }

        window.addEventListener('popstate', function (event) {
          const state = event.state
          let candidatesLoaded = false
          if (typeof state === 'object' && state !== null) {
            if (typeof state.q === 'object' && state.q !== null && state.q.id && state.q.text) {
              // has saved selection
              candidatesLoaded = true
              const newOption = new Option(state.q.text, state.q.id, true, true)
              $searchField?.append(newOption).trigger('change')
              window.cManager?.fetchContent(state.q)
            } else if (state.q == null) {
              // selection has been cleared
              candidatesLoaded = true
              $searchField?.val('').trigger('change')
              window.cManager?.fetchContent()
            }
          }
          if (!candidatesLoaded) {
            // no push state found, perform initial query
            $searchField?.val('').trigger('change')
            window.cManager?.fetchContent()
          }
        })

        if (window.cManager && window.qFilter) {
          const newOption = new Option(window.qFilter.text, window.qFilter.id, true, true)
          $searchField?.append(newOption).trigger('change')
          window.cManager?.fetchContent(window.qFilter)
        }
      }
    }
  }

  if (document.querySelector('body.candidates.candidate-profile-show')) {
    const candidateEventsGridEl = document.querySelector('div[data-is="CandidateEventsGrid"]')
    if (candidateEventsGridEl instanceof HTMLElement) {
      window.candidateEvents = tsInitVue(CandidateEventsGrid, candidateEventsGridEl, {
        listUrl: candidateEventsGridEl.dataset.listUrl
      })

      const editProfileBtn = document.querySelector('button[data-action="edit-profile"]')
      if (editProfileBtn instanceof HTMLElement) {
        const candidateModalEl = document.querySelector('div[data-is="CandidateModal"]')
        if (candidateModalEl instanceof HTMLElement) {
          const cModal = tsInitVue(CandidateModal, candidateModalEl, {
            modalTitle: 'Edit profile',
            onSuccess: function() {
              window.location.href = window.location.href
            }
          })

          editProfileBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const url = editProfileBtn.dataset.url
            if (url) {
              cModal.showModal(url, null)
            }
          })
        }
      }
    }
  }
})
